"use strict";

const IncidentToDoController = function () {
  const clearFlaggedIncidents = async function (incidentIds) {
    try {
      await ToDoFunctions.showConfirmClearToDoListConfirm(incidentIds.length, {
        selectedToDosName: "flagged incident",
        confirmButton: "Clear Flagged Incidents",
      });
    } catch (e) {
      return;
    }

    await ApiCalls.iddeToDoClearFlaggedIncidents(incidentIds);

    IncidentsGeoServerLayer.invalidateLayerData();
  };

  return {
    clearFlaggedIncidents,
  };
};

module.exports = IncidentToDoController();

const ApiCalls = require("../../apiCalls");
const ToDoFunctions = require("../../mapFunctions/toDoFunctions");
const IncidentsGeoServerLayer = require("./incidentsGeoServerLayer");
